import moment from 'moment'
import $router from 'src/router'

import { LocalStorageService } from 'src/services'
import { DATE_PICKER_MIN_YEAR, DATE_PICKER_MAX_YEAR } from 'src/constants/index.js'

const initSettings = () => ({
  month: moment().month(),
  quarter: 1,
  year: moment().year(),
  viewType: 'daysOfMonth',
  dealerGroupId: null,
  dealerShipId: '0',
  customGroupId: null,
  dealerGroupIds: null,
})

const getMMDDYY = (date) => {
  const dd = date.getDate().toString().padStart(2, '0')
  const mm = (date.getMonth() + 1).toString().padStart(2, '0')
  const yy = date.getFullYear().toString().slice(2)

  return `${mm}.${dd}.${yy}`
}

export default {
  state: {
    settings: initSettings(),
  },
  mutations: {
    SET_SETTINGS(state, payload) {
      state.settings = payload
    },
  },
  actions: {
    async updateSettings(
      { commit, state },
      {
        month,
        quarter,
        year,
        viewType,
        dealerGroupId,
        dealerShipId,
        startDate,
        endDate,
        customGroupId,
        dealerGroupIds,
        shouldRouterPush = true,
      }
    ) {
      const payload = {
        month,
        quarter,
        year,
        viewType,
        dealerGroupId,
        dealerShipId,
        startDate,
        endDate,
        customGroupId,
        dealerGroupIds,
      }
      const newSettings = {
        ...state.settings,
      }

      for (const [key, value] of Object.entries(payload)) {
        if (value !== undefined) {
          newSettings[key] = value
        }
      }

      commit('SET_SETTINGS', newSettings)
      LocalStorageService.set('settings', newSettings)

      if (shouldRouterPush) {
        await $router.toggleQueryParams({ add: newSettings })
      }

      return newSettings
    },
    clearSettings({ commit }) {
      LocalStorageService.remove('settings')
      commit('SET_SETTINGS', initSettings())
    },
  },
  getters: {
    allDealershipId() {
      return 0
    },
    isSpecificDealershipSelected(state, getters) {
      return +state.settings.dealerShipId !== getters.allDealershipId
    },
    isMultipleDealershipsSelected(state, getters) {
      const { dealerShipId } = state.settings
      return (
        +dealerShipId === getters.allDealershipId || dealerShipId.toString().split(',').length > 1
      )
    },
    isMonthView(state) {
      return state.settings.viewType === 'daysOfMonth'
    },
    isQuarterView(state) {
      return state.settings.viewType === 'monthsOfQuarter'
    },
    isYearView(state) {
      return state.settings.viewType === 'monthsOfYear'
    },
    isCustomView(state) {
      return state.settings.viewType === 'custom'
    },
    isCanEditBudget(state, getters) {
      return getters.isSpecificDealershipSelected && getters.isMonthView
    },
    months() {
      const months = moment.months().map((month, index) => ({ label: month, value: index }))

      return [months.slice(0, 6), months.slice(6)]
    },
    years() {
      const result = []

      for (let i = DATE_PICKER_MIN_YEAR; i <= DATE_PICKER_MAX_YEAR; i++) {
        result.unshift(i)
      }

      return result
    },
    quarters() {
      return {
        1: '1st',
        2: '2nd',
        3: '3rd',
        4: '4th',
      }
    },
    dealerGroupName(state, getters, { dealer }) {
      return (id = Number(state.settings.dealerGroupId)) => {
        const { name } = dealer.dealers.find((item) => item.id === id)

        return name
      }
    },
    period(state, getters) {
      const { year, quarter, month, startDate, endDate } = state.settings

      if (getters.isYearView) {
        return `${year} year`
      }

      if (getters.isQuarterView) {
        return `${getters.quarters[quarter]} Qtr ${year}`
      }

      if (getters.isMonthView) {
        return `${moment(Number(month) + 1, 'M').format('MMMM')} ${year}`
      }

      return `${getMMDDYY(new Date(`${startDate}T00:00:00`))} - ${getMMDDYY(
        new Date(`${endDate}T00:00:00`)
      )}`
    },
  },
}
